module.exports = __webpack_public_path__ + "img/btn-middle.52b57c7f.png";